// This file is automatically generated. Do not edit manually.

import { PartRevisionCostCalculationLogView } from "src/api/generated/erp/db/types/tables/partRevisionCostCalculationLogView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartRevisionCostCalculationLogApi {
	export async function getPartRevisionCostCalculationLogs(args: {
		partRevisionId: number;
	}): Promise<Array<PartRevisionCostCalculationLogView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/costCalculationLog/getPartRevisionCostCalculationLogs",
			method: "POST",
			data: {
				partRevisionId: args.partRevisionId,
			},
		});
		return response as Array<PartRevisionCostCalculationLogView>;
	}
}
